'use es6';

import { brandingHtmlElement } from './html/brandingHtmlElement';
import hsCmsFreeBrandingStyles from '!bender-url!../css/hsCmsFreeBranding.css';
import { attachStylesheet, onReady, toggleARIABooleanAttribute, toggleClassName } from './utils/domHelpers';
const collapsedClassName = 'hs-cmsf-branding__dropdown--collapsed';

const insertBranding = () => {
  attachStylesheet(hsCmsFreeBrandingStyles);
  document.body.appendChild(brandingHtmlElement);
};

const initBranding = () => {
  document.addEventListener('click', ({
    target
  }) => {
    const brandingWidget = document.getElementById('hs-cmsf-branding');
    const brandingWidgetButton = document.getElementsByClassName('hs-cmsf-branding__button')[0];
    const brandingWidgetDropdown = document.getElementById('hs-cmsf-branding__dropdown');

    if (brandingWidget.contains(target)) {
      toggleClassName(brandingWidgetDropdown, collapsedClassName);
      toggleARIABooleanAttribute(brandingWidgetButton, 'aria-expanded');
    } else {
      brandingWidgetDropdown.classList.add(collapsedClassName);
      brandingWidgetButton.setAttribute('aria-expanded', 'false');
    }
  });
};

const start = () => {
  if (!window.hsInEditor) {
    insertBranding();
    initBranding();
  }
};

onReady(start);
export default brandingHtmlElement;